import { render, staticRenderFns } from "./AdminLogMemo1.vue?vue&type=template&id=65d5f4dd&scoped=true"
import script from "./AdminLogMemo1.vue?vue&type=script&lang=js"
export * from "./AdminLogMemo1.vue?vue&type=script&lang=js"
import style0 from "./AdminLogMemo1.vue?vue&type=style&index=0&id=65d5f4dd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d5f4dd",
  null
  
)

export default component.exports